import { useMemo } from "react";

import { ANIMATION_DURATION } from "../AnimatedDot";

// Utility function to get a global animation delay
function getGlobalAnimationDelay() {
  return -((performance.now() / 1000) % ANIMATION_DURATION);
}

// Hook to get a global sync offset ONCE per mount
export function usePolyAnimationSync() {
  const sync = useMemo(() => getGlobalAnimationDelay(), []);
  return { sync };
}
